<script setup lang="ts">
import { computed } from 'vue'
import { useVmStore } from '@/stores/vm'
import { useTagStore } from '@/stores/tags'
// Declare incoming props
const { imgname, tagname } = defineProps<{ imgname: string; tagname: string }>()
const tagStore = useTagStore()
// Access Pinia store
const vm = useVmStore()

// Compute whether any filtered product has this tagName
const hasTag = computed(() =>
  vm.filteredProducts.some(
    product => Array.isArray(product.tags) && product.tags.includes(tagname)
  )
)

function selectTag(view) {
  if (view) {
    tagStore.select(view)
  }
 }
</script>

<template>
  <img
    v-if="hasTag"
    v-async-image="imgname"
    :alt="tagname"
     @click="selectTag(tagname)"
    style="width:70px;height:76px;"
    class="cursor-pointer"
  />
</template>
